export const BellIcon = ({
  scale = 1,
  className,
}: {
  scale?: number;
  className?: string;
}) => {
  return (
    <svg
      width={14 * scale}
      height={14 * scale}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_623_709)">
        <path
          d="M5.98975 12.25C6.09215 12.4273 6.23942 12.5746 6.41677 12.677C6.59412 12.7794 6.7953 12.8333 7.00008 12.8333C7.20486 12.8333 7.40604 12.7794 7.58339 12.677C7.76074 12.5746 7.90801 12.4273 8.01041 12.25M12.8334 4.66665C12.8334 3.32498 12.3667 2.15832 11.6667 1.16665M2.33341 1.16665C1.63341 2.15832 1.16675 3.32498 1.16675 4.66665M1.90291 8.94015C1.82671 9.02367 1.77642 9.12754 1.75816 9.23912C1.73991 9.3507 1.75447 9.46518 1.80008 9.56863C1.84569 9.67209 1.92038 9.76006 2.01506 9.82184C2.10975 9.88363 2.22035 9.91657 2.33341 9.91665H11.6667C11.7798 9.91669 11.8904 9.88388 11.9852 9.82221C12.0799 9.76054 12.1547 9.67267 12.2004 9.56928C12.2462 9.46589 12.2609 9.35145 12.2428 9.23986C12.2246 9.12827 12.1745 9.02435 12.0984 8.94073C11.3226 8.14098 10.5001 7.29107 10.5001 4.66665C10.5001 3.73839 10.1313 2.84815 9.47496 2.19178C8.81858 1.5354 7.92834 1.16665 7.00008 1.16665C6.07182 1.16665 5.18158 1.5354 4.52521 2.19178C3.86883 2.84815 3.50008 3.73839 3.50008 4.66665C3.50008 7.29107 2.677 8.14098 1.90291 8.94015Z"
          stroke="black"
          stroke-width="0.583333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_623_709">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
